"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COMPONENT_NAME = exports.C2C_COLORS = void 0;
var _react = _interopRequireWildcard(require("react"));
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));
var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.modal-atencion-emp"));
var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("./utils.js");
require("./CallMeBackFloatingEmp.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const C2C_COLORS = {
  WHITE: 'white',
  BLACK: 'black',
  CORAL: 'coral',
  AMBAR: 'ambar',
  GrEY2: 'grey2'
};
exports.C2C_COLORS = C2C_COLORS;
const COMPONENT_NAME = 'ContactCircle';
exports.COMPONENT_NAME = COMPONENT_NAME;
const CallMeBackFloatingEmp = props => {
  const [ContactCircleShow, setContactCircleShow] = (0, _react.useState)(true);
  const {
    modalAtencionConfig,
    components,
    visible,
    Modal,
    SvgIconLoader
  } = props;
  let {
    taggingInfo
  } = props;
  if (!taggingInfo) {
    taggingInfo = {
      componentProduct: components['Button-llamada'].product || '',
      componentVariation: components['Button-llamada'].campaign || 'all',
      componentName: COMPONENT_NAME
    };
  }
  const setUpModalProps = () => {
    Modal.setModalProps({
      contentPosition: 'right--center',
      opacityLayoutColor: 'black05',
      inSceneEffect: 'faseInLeft',
      outSceneEffect: 'fadeOutRight',
      closeByClickingOutside: true,
      scrollAllowed: false
    });
  };
  const handleNewModal = item => {
    setUpModalProps();
    Modal.setContent( /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
      Modal: Modal,
      taggingInfo: _objectSpread({}, taggingInfo),
      SvgIconLoader: SvgIconLoader,
      campaign: item.campaign,
      product: `Interes ${item.product}`,
      tabsOptions: _objectSpread(_objectSpread({}, modalAtencionConfig), {}, {
        tabsOptionPreChecked: item.option
      })
    }));
    return Modal.show();
  };
  if (ContactCircleShow && visible) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "ContactCircle",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        className: "ContactCircle__close",
        onClick: () => setContactCircleShow(false),
        taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
          componentContent: 'cerrar'
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, _objectSpread({
          taggingInfo: true
        }, components['SvgIconLoader-cerrar']))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread(_objectSpread({
        className: "ContactCircle__button"
      }, components['Button-llamada']), {}, {
        taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
          componentContent: 'interes'
        }),
        onClick: () => {
          handleNewModal(components['Button-llamada']);
        }
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ContactCircle__icon",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, _objectSpread({
          taggingInfo: true
        }, components['SvgIconLoader-icono']))
      })]
    });
  }
  return null;
};
CallMeBackFloatingEmp.defaultProps = {
  visible: true,
  segment: _utils.SEGMENT.EMP,
  flotanteProps: {
    iconId: 'Fijo',
    iconKind: 'M',
    iconSize: 31,
    iconColor: 'grey6',
    iconSegment: 'emp',
    desktopContainerTop: 418,
    mobileContainerTop: 256,
    iconContainerColor: 'ambar',
    backgroundColor: 'grey2',
    title: 'Te asesoramos'
  }
};
CallMeBackFloatingEmp.propTypes = {
  /**
   * {
   *  "info": "Segmento para definir carta de colores correspondiente",
   *  "kind": "both",
   *  "beautifulName": "segment"
   * }
   */
  segment: _propTypes.default.oneOf([_utils.SEGMENT.GP, _utils.SEGMENT.EMP]),
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes.default.string,
  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: _propTypes.default.object,
  /**
   * {
   *  "info": "Visibiliza el componente",
   *  "kind": "both",
   *  "beautifulName": "Visible"
   * }
   */
  visible: _propTypes.default.bool,
  /**
   * {
   *  "info": "Definiciones de los subcomponentes que puede recibir",
   *  "kind": "both",
   *  "beautifulName": "Subcomponentes"
   * }
   */
  components: _propTypes.default.object.isRequired,
  Modal: _propTypes.default.func.isRequired
};
var _default = CallMeBackFloatingEmp;
exports.default = _default;

//# sourceMappingURL=index.js.map